import React from "react";
import {useState,useEffect} from "react";
import {useLocation,useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import {Box} from "@mui/system";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Dialog} from "primereact/dialog";
import {confirmDialog} from "primereact/confirmdialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import {BlockUI} from "primereact/blockui";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Calendar} from "primereact/calendar";
import {Dropdown} from "primereact/dropdown";
import {MultiSelect} from "primereact/multiselect";
import Message from "../Helpers/Message.js";
import {fetch_url_post,format_date,fetch_download} from "../../Sources/js/app.js";

let oper="";

let currentDate=new Date();
let currentYear=currentDate.getFullYear();
let currentMonth=currentDate.getMonth()+1;
let yearsList=[];
let monthsList=[
	{
		label: "IANUARIE",
		value: 1,
	},
	{
		label: "FEBRUARIE",
		value: 2,
	},
	{
		label: "MARTIE",
		value: 3,
	},
	{
		label: "APRILIE",
		value: 4,
	},
	{
		label: "MAI",
		value: 5,
	},
	{
		label: "IUNIE",
		value: 6,
	},
	{
		label: "IULIE",
		value: 7,
	},
	{
		label: "AUGUST",
		value: 8,
	},
	{
		label: "SEPTEMBRIE",
		value: 9,
	},
	{
		label: "OCTOMBRIE",
		value: 10,
	},
	{
		label: "NOIEMBRIE",
		value: 11,
	},
	{
		label: "DECEMBRIE",
		value: 12,
	},
];

for(let i=-2;i<2;i++) {
	let cYear={
		label: currentYear+i,
		value: currentYear+i
	}
	yearsList.push(cYear);
} 

let defaultInputValues={
	id: null,
	no: "",
	year: currentYear,
	month: currentMonth,
	filter_providers: "",
	filter_years: currentYear,
	filter_months: [currentMonth],
};

let defaultDataValues={
	notesList: [],
	providersList: [],
};

let defaultDialogValues={
	openAddEdit: false,
	titleAddEdit: "",
};

let defaultInputError={
	disableSave: false,
	errorText: "",
};

let initialValue={};

const CommandNotes = (props) => {

	var timerId=null;
	defaultInputValues.id=(props.noteId?props.noteId:null);

	const [inputValues, setInputValues] = useState(defaultInputValues);
	const [dataValues, setDataValues] = useState(defaultDataValues);
	const [messageText, setMessageText] = useState(null);
	const [dataOk, setDataOk] = useState(false);
	const [dialogValues, setDialogValues] = useState(defaultDialogValues);
	const [inputError, setInputError] = useState(defaultInputError);	
	const [blockScreen, setBlockScreen] = useState(false);
	const [notesList, setNotesList] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();

	const handleChange = evt => {
		const {name, value} = evt.target;
		if(name==="no") {
			let found=false;
			if(dataValues.notesList.length>0) {
				dataValues.notesList.forEach(element => {
					if(value===element.no) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja o nota de comanda cu acest numar!":""),
			}
			setInputError(tmp);
		}
		if(name==="filter_providers") {
			setNotesList(dataValues.notesList
											.filter((note)=>((note.provider_name.toLowerCase().indexOf(value.toLowerCase())>-1)||(value==="")))
											.filter((note)=>((note.year===inputValues.filter_years)||(inputValues.filter_years==="")))
											.filter((note)=>(inputValues.filter_months.includes(note.month)))
			);
		}
		if(name==="filter_years") {
			setNotesList(dataValues.notesList
											.filter((note)=>((note.provider_name.toLowerCase().indexOf(inputValues.filter_providers.toLowerCase())>-1)||(inputValues.filter_providers==="")))
											.filter((note)=>((note.year===value)||(value==="")))
											.filter((note)=>(inputValues.filter_months.includes(note.month)))
			);
		}
		if(name==="filter_months") {
			setNotesList(dataValues.notesList
											.filter((note)=>((note.provider_name.toLowerCase().indexOf(inputValues.filter_providers.toLowerCase())>-1)||(inputValues.filter_providers==="")))
											.filter((note)=>((note.year===inputValues.filter_years)||(inputValues.filter_years==="")))
											.filter((note)=>(value.includes(note.month)))
			);
		}
		setInputValues({...inputValues,[name]:value});
	}

	const handleButton = (evt,what,elementData) => {
		if(what==="add") {
			setInputValues(defaultInputValues);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Adaugare nota noua"});
			setInputError(defaultInputError);
		}
		if(what==="generate") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(inputValues.year==="") {
				setMessageText("Eroare: Selectati anul din lista!");				
				document.getElementById("year").classList.add("required_input_error");
				return false;
			}
			if(inputValues.month==="") {
				setMessageText("Eroare: Selectati luna din lista!");				
				document.getElementById("month").classList.add("required_input_error");
				return false;
			}
			let url="generateCommandNotes";
			url+="?session_id="+props.session.sessId;
			oper="generate";
			let data={...inputValues};
			let tmp=inputValues.filter_months;
			tmp.indexOf(inputValues.month)===-1?tmp.push(inputValues.month):console.log("Already esistsing month.");
			setInputValues({...inputValues,filter_months:tmp,
											filter_years: inputValues.year,
			});
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="export") {
			let url="getXLSCommandNote";
			oper="download";
			url+="?session_id="+props.session.sessId;
			let data={
				provider_id: elementData.provider_id,
				year: elementData.year,
				month: elementData.month,
				no: elementData.no,
				provider_name: elementData.provider_name,
				date: elementData.reg_date_parsed,
			};
			let tmp=monthsList.filter((month)=>(month.value==elementData.month));
			fetch_download(url,data,"Nota_comanda_nr_"+elementData.no+"_"+elementData.year+"-"+tmp[0].label,success_handler);
			setBlockScreen(true);
			setMessageText("Se genereaza raportul...");
		}
	}

	const success_handler = (result) => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
			setMessageText("");
		}
		if(result.ok===0) {
			setMessageText("Eroare: "+result.error);
			return false;
		}
		if(result.is_auth===0) {
			navigate("/login");			
			return false;
		}
		if(result.message) {
			setMessageText(result.message);			
		}
		if((oper==="get")||(oper==="generate")) {
			setDialogValues(defaultDialogValues);
			if(oper==="get") {
				setDataValues({...dataValues,notesList:(result.notesList?result.notesList:[]),
					providersList:(result.providersList?result.providersList:[])
				});
			}else{
				setDataValues({...dataValues,notesList:(result.notesList?result.notesList:[])});
			}
			setNotesList(result.notesList?result.notesList
															.filter((note)=>((note.provider_name.toLowerCase().indexOf(inputValues.filter_providers.toLowerCase())>-1)||(inputValues.filter_providers==="")))
															.filter((note)=>((note.year===inputValues.filter_years)||(inputValues.filter_years==="")))
															.filter((note)=>(inputValues.filter_months.includes(note.month)))
			:[]);
            if(!dataOk) {
                setDataOk(true);
            }
			oper="";
		}
		if(oper==="download") {
			setMessageText(null);
			setBlockScreen(false);
			oper="";
		}
	}

	const fail_handler = () => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
		}
		setMessageText("Eroare de conexiune. Va rugam sa incercati mai tarziu!");
	}

	const wait_handler = () => {
		setBlockScreen(true);
		setMessageText("Operatiunea este in curs...");
	}

	useEffect(() => {
		if(props.session.sessId) {
			oper="get";
			let url="getCommandNotes";
			url+="?session_id="+props.session.sessId;
			let data={};
			fetch_url_post(url,data,success_handler,fail_handler);
		}else{
			navigate("/login");
		}
	},[props.session.sessId]);

	const addEditDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEdit} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})} className="responsive-dialog-small">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={12} lg={6} className="field padding-med">
						<label htmlFor="year">Anul*</label>
						<Dropdown name="year" id="year" style={{"width":"100%"}} options={yearsList} value={inputValues.year} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={6} className="field padding-med">
						<label htmlFor="month">Luna*</label>
						<Dropdown name="month" id="month" style={{"width":"100%"}} options={monthsList} value={inputValues.month} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Genereaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"generate")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const tableColTemplate = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Tipareste" icon="pi pi-print" tooltip="Tipareste nota de comanda" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"export",row_data)}/>
				</span>
			);
		}
		if(column.field==="month") {
			let tmp=monthsList.filter((month)=>(month.value==row_data.month));
			return(
				<span>
					{tmp[0].label}
				</span>
			);
		}
	}

	const confirm = (evt,what,elementData) => {
		if(what==="delete") {
			confirmDialog({
				message: "Sigur doriti stergerea?",
				header: "Confirmare stergere",
				icon: "pi pi-exclamation-triangle",
				accept: () => handleButton(evt,what,elementData),
				reject: () => null,
			});
		}
	}

	if(dataOk) {
		return(
			<BlockUI blocked={blockScreen} fullScreen>
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={6} md={6} lg={3} xl={3} className="field padding-med">
							<InputText name="filter_providers" id="filter_providers" style={{"width":"100%"}} value={inputValues.filter_providers} placeholder="Cauta furnizor..." onChange={(evt) => handleChange(evt)}/>							
						</Grid>						
						<Grid item xs={12} sm={6} md={6} lg={3} xl={3} className="field padding-med">
							<div style={{"width":"99%","float":"left"}}>
								<Dropdown name="filter_years" id="filter_years" style={{"width":"40%"}} options={yearsList} value={inputValues.filter_years} onChange={(evt) => handleChange(evt)}/>
								<MultiSelect name="filter_months" id="filter_months" style={{"width":"57%","marginLeft":"6px","height":"38px","lineHeight":"0.8"}} options={monthsList} value={inputValues.filter_months} optionLabel="label" optionValue="value" onChange={(evt) => handleChange(evt)}/>	
							</div>
						</Grid>						
						<Grid item xs={12} sm={6} md={6} lg={4} xl={4} className="field padding-med text-left">
							<h6 style={{"marginTop":"9px","color":"#000000","marginLeft":"18px"}}>{notesList.length} {(((notesList.length>1)||(notesList.length===0))?" inregistrari gasite.":" inregistrare gasita.")}</h6>
						</Grid>						
						<Grid item xs={12} sm={6} md={6} lg={2} xl={2} className="field padding-med text-right">
							<Button label="Genereaza note" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add")}}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<div className="card">
							<DataTable
								value={notesList}
								scrollable
								scrollHeight="60vh"
								style={{"minHeight":"63vh"}}
								scrollDirection="both"
								stripedRows
								resizableColumns
								columnResizeMode="fit"
								responsiveLayout="stack"
								emptyMessage="Nu exista inregistrari"
							>
								<Column field="no" header="Numar" style={{"flexGrow":"0","flexBasis":"120px"}} sortable></Column>
								<Column field="year" header="Anul" style={{"flexGrow":"0","flexBasis":"100px"}}></Column>
								<Column field="month" header="Luna" style={{"flexGrow":"0","flexBasis":"130px"}} body={tableColTemplate}></Column>
								<Column field="provider_name" header="Furnizor" style={{"flexGrow":"1","flexBasis":"450px"}} sortable></Column>								
								<Column field="created_by" header="Generat de" style={{"flexGrow":"1","flexBasis":"300px"}} sortable></Column>								
								<Column field="reg_date_parsed" header="Data introducerii" style={{"flexGrow":"0","flexBasis":"180px"}} sortable></Column>
								<Column field="buttons" header="" style={{"flexGrow":"0","flexBasis":"120px"}} body={tableColTemplate}></Column>
							</DataTable>
						</div>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
				<ConfirmDialog />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
				{dialogValues.openAddEdit && addEditDialog()}
            </BlockUI>
		);
	}else{
		return(
			<React.Fragment>
				<LinearProgress />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
			</React.Fragment>
		);		
	}
};

export default CommandNotes;


